import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild, ElementRef, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ContainerComponent } from '../../layout/container/container.component';
import { AnalyticsService } from '../../../services/analytics.service';

import { environment } from "../../../../environments/environment";

@Component({
  selector: 'app-cash-advance',
  standalone: true,
  imports: [CommonModule, RouterModule, ContainerComponent],
  templateUrl: './cash-advance.component.html',
  styleUrl: './cash-advance.component.scss'
})
export class CashAdvanceComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('sectionElement', { static: false }) sectionElement?: ElementRef;
  isScrolled = false; // Nueva propiedad para controlar el scroll

  constructor(private readonly analyticsService: AnalyticsService) {}

  ngOnInit() {
    // Track banner view when component loads
    setTimeout(() => this.trackBannerView(), 100);
  }

  ngAfterViewInit() {
    // Registrar la sección para tracking de analytics
    if (this.sectionElement?.nativeElement) {
      this.analyticsService.registerSectionForTracking(
        this.sectionElement.nativeElement,
        'Cash Advance',
        'cash-advance-section'
      );
    }
  }

  ngOnDestroy() {
    // Unregister section from analytics tracking
    if (this.sectionElement?.nativeElement) {
      this.analyticsService.unregisterSectionFromTracking(this.sectionElement.nativeElement);
    }
  }

  // Listener para detectar scroll
  @HostListener('window:scroll', ['$event'])
  onWindowScroll() {
    // Mostrar botones flotantes solo en móvil cuando el usuario haga scroll hacia abajo
    this.isScrolled = window.scrollY > 100 && window.innerWidth <= 768;
  }

  // Listener para detectar cambios de tamaño de ventana
  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    // Ocultar botones si se cambia a desktop
    if (window.innerWidth > 768) {
      this.isScrolled = false;
    }
  }

  // Método para manejar el click en el banner
  onBannerClick(): void {
    console.log('🖱️ Cash Advance: Clic en banner');

    // Track banner click event
    this.trackBannerClick();
  }

  // Método para rastrear el click en el banner
  private trackBannerClick(): void {
    const eventData = this.analyticsService.createPromotionEventData(
      0, // ID del banner (0 para banner principal)
      this.getCurrentDeviceType(),
      'Cash Advance Banner - Super Avance hasta $4.000.000',
      'assets/familia_usando_portatil.png',
      'cash_advance_banner'
    );

    this.analyticsService.trackPromotionSelection(eventData);
  }

  // Método para rastrear cuando se muestra el banner (view) - solo si es visible
  private trackBannerView(): void {
    if (!this.sectionElement?.nativeElement) return;

    const eventData = this.analyticsService.createPromotionEventData(
      0, // ID del banner (0 para banner principal)
      this.getCurrentDeviceType(),
      'Cash Advance Banner - Super Avance hasta $4.000.000',
      'assets/familia_usando_portatil.png',
      'cash_advance_banner'
    );

    this.analyticsService.trackPromotionViewIfVisible(eventData, this.sectionElement.nativeElement);
  }

  // Método para detectar el tipo de dispositivo
  private getCurrentDeviceType(): 'xl' | 'desktop' | 'tablet' | 'movil' {
    const width = window.innerWidth;
    if (width >= 1200) return 'xl';
    if (width >= 1024) return 'desktop';
    if (width >= 768) return 'tablet';
    return 'movil';
  }

  // Método para abrir auto-apertura
  openAutoApertura(): void {
    window.open('https://www.unipay.cl/autoatencion-ptoventa/validar-identidad', '_blank', 'noopener,noreferrer');
  }

  // Método para abrir pago de estado de cuenta
  openPagoEstadoCuenta(): void {
    window.open(environment.urlBase+'/pago', '_blank', 'noopener,noreferrer');
  }
}
